import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const FRAMES = [
  { src: "/assets/demo/f1_prompt.png", step: "01 // Prompt", caption: "Type the asset you want — one object, clear style" },
  { src: "/assets/demo/f2_glb.png", step: "02 // Generate", caption: "TRELLIS turns the concept into real, inspectable 3D geometry" },
  { src: "/assets/demo/f3_packs.png", step: "03 // Assemble", caption: "Group models into a themed, sellable pack" },
  { src: "/assets/demo/f5_market.png", step: "04 // Sell", caption: "Approved packs go live on the marketplace with a price" },
  { src: "/assets/demo/f4_earnings.png", step: "05 // Earn", caption: "Bounty lands on approval — royalties stack on every sale" },
];

export default function DemoReel({ testid = "demo-reel" }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % FRAMES.length), 4200);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid={testid} className="border border-white/10 bg-black/40 mb-16">
      <div className="px-8 pt-8 pb-4 flex items-baseline justify-between flex-wrap gap-2">
        <h2 className="font-sans font-bold uppercase tracking-tight text-2xl sm:text-3xl text-zinc-50">Watch a pack get made</h2>
        <p className="font-mono text-[10px] text-zinc-500 uppercase tracking-[0.2em]">Real screens from the live pipeline — nothing staged</p>
      </div>
      <div className="relative aspect-[16/9] max-h-[560px] overflow-hidden border-y border-white/10">
        <AnimatePresence mode="sync">
          <motion.img
            key={FRAMES[idx].src}
            src={FRAMES[idx].src}
            alt={FRAMES[idx].caption}
            className="absolute inset-0 w-full h-full object-cover object-top"
            initial={{ opacity: 0, scale: 1.02 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          />
        </AnimatePresence>
        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black via-black/70 to-transparent px-6 pb-5 pt-16">
          <p data-testid="demo-reel-step" className="font-mono text-[10px] tracking-[0.3em] text-nc-orange uppercase">{FRAMES[idx].step}</p>
          <p className="font-mono text-xs text-zinc-200 mt-1.5">{FRAMES[idx].caption}</p>
        </div>
      </div>
      <div className="px-8 py-4 flex gap-2">
        {FRAMES.map((f, i) => (
          <button
            key={f.step}
            data-testid={`demo-reel-dot-${i}`}
            onClick={() => setIdx(i)}
            className="flex-1 h-1 bg-white/10 relative overflow-hidden"
            aria-label={f.step}
          >
            {i === idx && <motion.div className="absolute inset-y-0 left-0 bg-nc-blue" initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: 4.2, ease: "linear" }} />}
            {i < idx && <div className="absolute inset-0 bg-nc-blue/50" />}
          </button>
        ))}
      </div>
    </div>
  );
}
